"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTransferInProgressMockData = void 0;
const enums_1 = require("../../enums");
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const icons_1 = require("../icons");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const buildTransferInProgressMockData = ({ orgName, color, isDarkMode, body, firstName = "John", formCategory = enums_1.TicketingFormCategory.Event, locale = "en", subject = "Your transfer is in progress", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme,
        iconZeffyLogo,
        lang: locale,
        subject,
        orgName: orgName || "Bright Futures Foundation",
        firstName,
        isSweepstakes: formCategory === enums_1.TicketingFormCategory.Sweepstakes,
        message: body,
    };
};
exports.buildTransferInProgressMockData = buildTransferInProgressMockData;
